module.exports = __webpack_public_path__ + "static/media/vc.b1d0f511.svg";